import { createActions } from 'reduxsauce';
import { removeSelectedItem } from '@iso/lib/helpers/CRUD';

export const { Types: types, Creators: actions } = createActions({
    requestDeletePartner: ['id'],
    deletePartnerSucceeded: ['id'],
    deletePartnerFailed: ['error'],
});

export default {
    [types.REQUEST_DELETE_PARTNER]: (state, { id }) => ({
        ...state,
        delete: {
            ...state.delete,
            id,
            loading: true,
            error: null,
        },
    }),
    [types.DELETE_PARTNER_SUCCEEDED]: (state, { id }) => ({
        ...state,
        data: removeSelectedItem(state.data, id),
        delete: {
            ...state.delete,
            id: null,
            loading: false,
        },
    }),
    [types.DELETE_PARTNER_FAILED]: (state, { error }) => ({
        ...state,
        delete: {
            ...state.delete,
            id: null,
            loading: false,
            error,
        },
    }),
};
